import MDTypography from "components/MDTypography";
import { Box, Tooltip } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";

function RowColorCell({ value, suffix, row }) {
  const CloseBy = row?.original?.taskClosedBy

  const DueDate = row.original.expectedCompletionDate;
  const taskCompletedDate = row.original.taskCompletedOn;
  const currentDateTime = new Date();
  const expectedDate = DueDate ? new Date(DueDate) : null;

  const isExpectedDateValid = expectedDate instanceof Date && !isNaN(expectedDate);


  const taskCompleted = taskCompletedDate ? new Date(taskCompletedDate) : null;
  const currentStats = row.original.currentStats;

  let backgroundColor = "transparent";
  let iconColor = "transparent";
  const hasValidValue = value !== null && value !== "";

  const colorTooltips = {
    "#73aaf2": "New",
    "#FB8C00": "In Progress",
    "#D81B60": "Pending For Approval",
    "#00B300": "Completed On Time",
    "#80ff80": "Completed With Delay",
    "#E53935": "Task is Delay",
    "00a800":"Closed By System"
  };

  if (hasValidValue) {
    if (!isExpectedDateValid && currentStats !== "Completed") {
      backgroundColor = "#73aaf2"; // Grey
      iconColor = "#73aaf2";
    }else if (currentStats === "New" && currentDateTime < expectedDate) {
      backgroundColor = "#73aaf2"; // Blue
      iconColor = "#73aaf2";
    } else if (
      currentStats !== "New" &&
      currentStats !== "Completed" &&
      currentStats !== "pending for approval" &&
      currentDateTime <= expectedDate
    ) {
      backgroundColor = "#FB8C00"; // Yellow
      iconColor = "#FB8C00";
    } else if (currentStats === "pending for approval") {
      backgroundColor = "#D81B60"; // Pink
      iconColor = "#D81B60";
    } else if (currentStats === "Completed" && taskCompleted < expectedDate) {
      backgroundColor = "#00B300"; // Green
      iconColor = "#00B300";
    } else if (currentStats === "Completed" && taskCompleted > expectedDate) {
      backgroundColor = "#80ff80"; // Light Green
      iconColor = "#80ff80";
    } else if (currentStats !== "Completed" && currentDateTime > expectedDate) {
      backgroundColor = "#E53935"; // Red
      iconColor = "#E53935";
    }else if (CloseBy=="System" && currentStats == "Completed"){
      backgroundColor = "#00a800"; // Green
      iconColor = "#00a800";
    }else {
      backgroundColor = "transparent";
      iconColor = "transparent";
    }
  }

  return (
    <Box
      sx={{
        backgroundColor: backgroundColor,
        padding: "8px",
        borderRadius: "0px",
        height: "100%",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Tooltip title={colorTooltips[backgroundColor] || ""} arrow>
        <CircleIcon
          sx={{ color: iconColor, fontSize: 20, marginRight: "8px" }}
        />
      </Tooltip>
      <Tooltip title={value && value.length > 30 ? value : ""} arrow>
        <MDTypography variant="caption" fontWeight="medium" color="text">
          {value && value.length > 30 ? `${value.substring(0, 30)}...` : value}
          {suffix && (
            <MDTypography
              variant="caption"
              fontWeight="medium"
              color="secondary"
            >
              &nbsp;&nbsp;{suffix}
            </MDTypography>
          )}
        </MDTypography>
      </Tooltip>
    </Box>
  );
}

RowColorCell.defaultProps = {
  suffix: "",
};

export default RowColorCell;
